import React from 'react'

export default function Footer() {
  return (
    <footer class="footer">
      <div class="d-sm-flex justify-content-center justify-content-sm-between">
        <span class="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © 2025 <a href="#" target="_blank">B. E. College Ex Students' Club</a>. All rights reserved.</span>
      </div>
    </footer>
  )
}
